import { withSvgIcon } from './withSvgIcon';

export const Mark = withSvgIcon(
  <>
    <circle cx="10" cy="10" r="8" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.11772 5.00163C8.93627 5.00163 8.79357 5.15671 8.80864 5.33754L9.27387 10.9203C9.28727 11.0811 9.42165 11.2047 9.58295 11.2047H10.4389C10.6002 11.2047 10.7345 11.0811 10.7479 10.9203L11.2132 5.33754C11.2282 5.15671 11.0855 5.00163 10.9041 5.00163H9.11772ZM10 14.9984C10.6852 14.9984 11.2406 14.443 11.2406 13.7578C11.2406 13.0727 10.6852 12.5172 10 12.5172C9.31486 12.5172 8.75944 13.0727 8.75944 13.7578C8.75944 14.443 9.31486 14.9984 10 14.9984Z"
      fill="white"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
